<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 class="pa-4 craneintro">
                Looking to upfit your service truck with the proper Venturo crane package? Our calculator takes into account your gross vehicle weight and the necessary boom length and maximum load capacity for your job, and it simplifies your search with a selection of appropriate products. Enter
                your info below to make sure you pick the most suitable Venturo product for light, moderate or heavy-duty applications.
            </v-flex>
        </v-layout>
        <v-form
                v-model="valid"
        >
            <v-layout row wrap class="formrow">
                <v-flex xs12 class="pa-4">
                    <v-alert
                            :value="errmsg"
                            transition="scale-transition"
                            type="warning"
                            dismissible
                    >
                        {{ respmessage }}
                    </v-alert>
                </v-flex>
                <v-flex sm6 class="pa-4">
                    <v-text-field
                            v-model="name"
                            label="1. Name">
                    </v-text-field>
                </v-flex>
                <v-flex sm6 class="pa-4">
                    <v-text-field
                            :rules="emailrules"
                            v-model="email"
                            label="2. Email">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="formrow">
                <!-- v-flex sm6 class="pa-4">
                    <v-text-field
                            v-model="gvwr"
                            label="3. Gross Vehicle Weight (GVW)">
                    </v-text-field>
                </v-flex -->
                <v-flex sm6 class="pa-4">
                    <v-text-field
                            v-model="boom"
                            label="3. Length of Boom Reach Needed (in feet)">
                    </v-text-field>
                </v-flex>
                <v-flex sm6 class="pa-4">
                    <v-text-field
                            v-model="cap"
                            label="4. Weight Capacity (in pounds)">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="formrow">
                <v-flex sm6 class="px-4">
                    Run Search
                    <br/>
                    <v-btn
                            :disabled="!valid"
                            @click="searchcranes">Search For Crane
                    </v-btn>
                    <v-btn
                            v-if="displaythese.length"
                            @click="clearem">Clear Results
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout row wrap v-if="displaythese.length">
            <v-flex xs12>
                <v-layout row wrap class="over">
                    <v-flex sm12 md4 class="px-4 py-2">
                        <strong class="headline">Search Results</strong>&nbsp;&nbsp;&nbsp;{{ displaythese.length }} matches
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="under" id="results-key-container">
                    <v-flex xs12 class="px-4 py-2 over subheading keytitle">
                        Results Key
                    </v-flex>
                    <v-flex xs12 class="px-4 py-2 over subheading iconlearnmore">
                        Click on any icon below to learn more.
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="under" id="results-key-icons">
                    <v-flex sm12 md3 class="px-4 py-2 text-xs-center" @click="showpowerkey('electric')">
                        <img src="/wp-content/themes/venturo/assets/img/electric-power-icon.png" class="modal-trigger" data-target="electric-modal-content">
                        <v-flex xs12 class="text-xs-center key-front-title">Electric</v-flex>
                    </v-flex>
                    <v-flex sm12 md3 class="px-4 py-2 text-xs-center" @click="showpowerkey('hydraulic')">
                        <img src="/wp-content/themes/venturo/assets/img/hydraulic-power-icon.png" class="modal-trigger" data-target="hydraulic-modal-content">
                        <v-flex xs12 class="text-xs-center key-front-title">Hydraulic</v-flex>
                    </v-flex>
                    <v-flex sm12 md3 class="px-4 py-2 text-xs-center" @click="showpowerkey('electric-hydraulic')">
                        <img src="/wp-content/themes/venturo/assets/img/electric-hydraulic-power-icon.png" class="modal-trigger" data-target="electric-hydraulic-modal-content">
                        <v-flex xs12 class="text-xs-center key-front-title">Electric-Hydraulic</v-flex>
                    </v-flex>
                    <v-flex sm12 md3 class="px-4 py-2 text-xs-center" @click="showpowerkey('hydraulic-vlc')">
                        <img src="/wp-content/themes/venturo/assets/img/hydraulic-vlc-power-icon.png" class="modal-trigger" data-target="electric-hydraulic-modal-content">
                        <v-flex xs12 class="text-xs-center key-front-title">Hydraulic-VLC</v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap id="results-container">
                    <div :class="'result-card ' + mitem.matchtype" v-for="(mitem, midx) in displaythese" :key=midx>
                        <!-- DYNAMIC DATA - Product Image URL -->
                        <div class="product-img" :style="'background-image: url(' + mitem.image + ');'">
                            <!-- DYNAMIC DATA - Product url href -->
                            <a class="product-title" :href="mitem.page" target="_blank">
                                <!-- DYNAMIC DATA - Product Title -->
                                {{ mitem.model }}
                            </a>
                        </div>

                        <div class="info-container">
                            <div class="info-column">
                                <span class="info-label"> Min. Vehicle GVWR </span>
                                <span class="info-value"> <!-- DYNAMIC DATA - Min. Vehicle GVWR --> {{ mitem.gvwr }} </span>
                            </div>

                            <div class="info-column">
                                <span class="info-label"> Boom Length (ft) </span>
                                <span class="info-value"> <!-- DYNAMIC DATA - Boom Length --> {{ mitem.boom }} </span>
                            </div>

                            <div class="info-column">
                                <span class="info-label"> Max. Capacity (lbs) </span>
                                <span class="info-value"> <!-- DYNAMIC DATA - Max. Capacity --> {{ mitem.cap }} </span>
                            </div>

                            <div class="info-column">
                                <span class="info-label"> POWER </span>
                                <div class="power-value-container">
                                    <!-- DYNAMIC DATA - Power Icon URL -->
                                    <span class="power-icon" :style="'background-image: url(/wp-content/themes/venturo/assets/img/' + mitem.icon + '.png)'"></span>
                                    <span class="info-value power-value"> <!-- DYNAMIC DATA - Power Value --> {{ mitem.power }} </span>
                                </div>
                            </div>
                        </div> <!-- ./info-container -->
                        <span :class="'power-feature ' + mitem.rotationclass"> Power Rotation </span>
                        <span :class="'power-feature ' + mitem.elevationclass"> Power Elevation </span>
                        <!-- DYNAMIC DATA - 'inactive' class -->
                        <span :class="'power-feature ' +  mitem.extensionclass"> Power Extension </span>

                        <!-- DYNAMIC DATA - product href link -->
                        <a class="card-footer" :href="mitem.page" target="_blank"> <!-- DYNAMIC DATA - product name --> View {{ mitem.model }} </a>
                    </div> <!-- ./result-card -->
                </v-layout>
                <v-layout row wrap class="text-xs-center buttonrow">
                    <v-flex xs12 md6 class="quotebutton">
                        <v-btn
                                class="button"
                                :href="'/support/get-a-quote/?search_results=' + reslist"
                        >
                            Get A Quote
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 md6 class="salesbutton">
                        <v-btn
                                class="button white"
                                :href="'/support/contact-sales/?search_results=' + reslist"
                        >
                            Contact Sales
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-dialog
                v-model="powerkey">
            <div id="venco-modal-content" class="modal-content">
                <v-flex xs12 class="text-xs-right closepowerkey" @click="powerkey = !powerkey">
                    X
                </v-flex>
                <img :src="powerkeyinfo.img" class="modal-icon">
                <h2 class="power-title">{{ powerkeyinfo.h2 }}</h2>
                <p class="powerkeydesc">{{ powerkeyinfo.desc }}</p>
                <p class="function-description">&#42; {{ powerkeyinfo.funcdesc }}</p>
            </div>

        </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'

  const qs = require('qs')

  /* eslint-disable no-console */

  export default {
    data: () => ({
      name: '',
      email: '',
      gvwr: '',
      boom: '',
      cap: '',
      displaythese: [],
      errmsg: false,
      respmessage: '',
      emailrules: [
        v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(v) || 'The system requires a valid email address.'
      ],
      valid: true,
      reslist: '',
      powerkey: false,
      powerkeyinfo: {}
    }),
    methods: {
      clearem () {
        this.cap = ''
        this.boom = ''
        this.gvwr = ''
        this.displaythese = []
        this.errmsg = false
        this.respmessage = ''
        this.reslist = ''
      },
      showpowerkey (what) {
        axios.get('/wp-content/themes/venturo/assets/powerkey/' + what + '.json', qs.stringify({})
        )
          .then(response => {
            this.powerkeyinfo = response.data
            this.powerkey = true
          })
          .catch(function (e) {
            console.log('showpowerkey ERROR HERE')
            console.log(e)
          })
      },
      searchcranes () {
        this.errmsg = false
        this.respmessage = ''
        let result = {}
        this.displaythese = []
        this.reslist = ''

        //axios.post('http://venco.constantvector.com/calculator/vc-calc.php', qs.stringify({})
        axios.post('/wp-content/themes/venturo/lib/calculator/vc-calc.php', qs.stringify({
            info: 'findboom',
            name: this.name,
            email: this.email,
            gvwr: this.gvwr,
            boom: this.boom,
            cap: this.cap
          })
        )
          .then(response => {
            // console.log(response.data)

            if (response.data.status === 'success') {
              result = Object.keys(response.data.candidates).map(function (key) {
                return response.data.candidates[key]
              })

              /* --- limiting to first 4 found --- */
              let upper = 4
              if (result.length < 4) {
                upper = result.length
              }
              // for (let idx = 0; idx < result.length; idx++) {}
              for (let idx = 0; idx < upper; idx++) {
                result[idx]['rotationclass'] = 'veryactive'
                result[idx]['elevationclass'] = 'veryactive'
                result[idx]['extensionclass'] = 'veryactive'

                if (result[idx].rotation.toLowerCase() === 'no') {
                  result[idx]['rotationclass'] = 'inactive'
                }

                if (result[idx].elevation.toLowerCase() === 'no') {
                  result[idx]['elevationclass'] = 'inactive'
                }

                if (result[idx].extension.toLowerCase() === 'no') {
                  result[idx]['extensionclass'] = 'inactive'
                }

                this.displaythese.push(result[idx])

                this.reslist = this.reslist + result[idx].model + ','
              }

              this.reslist = this.reslist.substring(0, this.reslist.length - 1)

              // console.log('DISP')
              // console.log(this.displaythese)
            } else {
              this.errmsg = true
              this.respmessage = response.data.reason
            }
          })
          .catch(function (e) {
            console.log('searchcranes ERROR HERE')
            console.log(e)
          })
      }
    }
  }
</script>

<style>
</style>
